interface IProps {
  hasintercom: boolean;
  intercom: string | number;
}

export const register = (props: IProps) => {
  if (!props.hasintercom) {
    return;
  }

  const script = document.createElement('script');
  (window as any).intercomSettings = { app_id: props.intercom };
  script.type = 'text/javascript';
  script.async = true;
  script.src = `https://widget.intercom.io/widget/${props.intercom}`;
  return script;
};
export const unregister = (props: IProps) => {
  if (!props.hasintercom) {
    return;
  }

  // eslint-disable-next-line sonarjs/no-duplicate-string
  ['intercom-css-container', 'intercom-frame'].forEach(id => {
    const node = document.getElementById(id);
    node?.parentNode.removeChild(node);
  });
  const nodes = document.getElementsByClassName('intercom-lightweight-app');

  for (let i = 0; i < nodes.length; i++) {
    nodes[i]?.parentNode.removeChild(nodes[i]);
  }

  Object.keys(window)
    .filter(key => key.toLocaleLowerCase().includes('intercom'))
    .forEach(key => delete (window as any)[key]);
};
